import { memo } from 'react';

import type { FormItemUiDefinition } from '../../../../types/formItem.ts';
import { getUiDefinitionStyles } from '../../../../utils/styles.ts';
import { RecordValueItemSpan, RecordValueItemWrapper } from './RecordValueItem.styles';

interface Props {
  value: string;
  cursorPointer?: boolean;
  onClick: (value: string) => void;
  formItemUiDefinition?: FormItemUiDefinition | null;
}

export const RecordValueItem = memo(({ value, cursorPointer, onClick, formItemUiDefinition }: Props) => {
  const uiDefinitionStyles = getUiDefinitionStyles(formItemUiDefinition ?? undefined);

  return (
    <RecordValueItemWrapper>
      <RecordValueItemSpan onClick={() => onClick(value)} isCursorPointer={cursorPointer} uiDefinitionStyles={uiDefinitionStyles}>
        {value}
      </RecordValueItemSpan>
    </RecordValueItemWrapper>
  );
});
